export const api = {
  login: "/user/login",
  signup: "/user/sign-up",
  user: "/user",
  transaction: "/transaction",
};

export enum STATUS {
  SUCCESS = 200,
  CREATED = 201,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  INTERNAL_SERVER_ERROR = 500,
}

export interface Response {
  result: any;
  success: boolean;
}
